module.exports = __webpack_public_path__ + "img/icon_arrow.a0124e8b.svg";